import { gql } from '@apollo/client';

export const ASK_SUPPORT_ASSISTANT = gql`
  mutation AskSupportAssistant($input: AskSupportAssistantInput!) {
    askSupportAssistant(input: $input) {
      success
      answer
      error
      conversationId
      citations {
        url
        urlPath
        title
        heading
      }
    }
  }
`;
